import { env } from './env';
import { getAppVersion, compareAppVersion } from './base';
import {
  login,
  logout,
  getUserId,
  getUser,
  getAccessToken,
  getDevice,
  getSearchHistory,
  getSystemInfo,
  purchase,
  multiPurchase,
  share,
  bindPhone,
  bindWechat,
  callMiniProgramme,
  backPressLinstener,
  toast,
  hasInstalled,
  jumpToPackage,
  checkNotification,
  getTeenagerMode,
  insertCalenderEvent,
  preventParentTouchEvent,
} from './action/common';
import { player } from './action/player';
import { modal } from './action/modal';
import { page } from './action/page';
import { log } from './action/log';
import { monitor } from './action/monitor';
import { route } from './route';
import { invokeSchemaByPrompt, invokeSchemaByIframe } from './core';

const qt = {
  env,
  login,
  logout,
  getUserId,
  getUser,
  getAccessToken,
  getAppVersion,
  compareAppVersion,
  getDevice,
  getSearchHistory,
  getSystemInfo,
  purchase,
  multiPurchase,
  share,
  bindPhone,
  bindWechat,
  callMiniProgramme,
  backPressLinstener,
  toast,
  hasInstalled,
  jumpToPackage,
  checkNotification,
  getTeenagerMode,
  insertCalenderEvent,
  preventParentTouchEvent,
  player,
  modal,
  page,
  log,
  monitor,
  route,
  invokeSchemaByPrompt,
  invokeSchemaByIframe,
};
export default qt;
